import React from 'react';

import {Helmet, useNavigate} from 'views/module';

import LoomLeadListScene from 'views/scenes/loom_lead/list/LoomLeadList';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomLeadList = () => {
  const clientReadFlag = useFlag(FLAGS.CLIENT_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (clientReadFlag.isLoading || clientReadFlag.isEnabled) return;

    navigate('/client_lead', {replace: true});
  }, [clientReadFlag.isEnabled, clientReadFlag.isLoading, navigate]);

  if (clientReadFlag.isLoading || !clientReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Leads (Loom)</title>
      </Helmet>
      <LoomLeadListScene />
    </>
  );
};

export default LoomLeadList;
